import { render, staticRenderFns } from "./List.vue?vue&type=template&id=24c66173&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c66173",
  null
  
)

export default component.exports